import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["type", "id", "disabled", "pattern", "placeholder", "required", "maxlength", "minlength", "autocomplete", "data-1p-ignore"];
import { computed } from "vue";
import { autocompleteAttr } from "./FormUtils";
import { inputType } from "./fieldControls";
import { toText } from "./fieldValues";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlText',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlText');
        const model = useFieldModel(() => toText(props.data));
        const type = computed(() => inputType(props.field.type));
        const autocomplete = computed(() => autocompleteAttr(fieldOptions.value));
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                onInput: _cache[1] || (_cache[1] = ($event) => (_unref(emitChange)(_unref(model)))),
                onFocus: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                onBlur: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                type: type.value,
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                pattern: _unref(fieldOptions).pattern ?? undefined,
                placeholder: _unref(fieldOptions).placeholder ?? undefined,
                required: _unref(fieldOptions).required ?? undefined,
                maxlength: _unref(fieldOptions).maxLength ?? undefined,
                minlength: _unref(fieldOptions).minLength ?? undefined,
                autocomplete: autocomplete.value,
                "data-1p-ignore": _unref(fieldOptions).autocomplete === false ? true : undefined,
                class: _normalizeClass(["form__control", { 'form__control--empty': !_unref(model) }])
            }, null, 42, _hoisted_1)), [
                [
                    _vModelDynamic,
                    _unref(model),
                    void 0,
                    { trim: true }
                ]
            ]);
        };
    }
});
